import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { Link } from 'gatsby'
import styled from 'styled-components'

import Angle from '../../atoms/Angle'
import { MysqlCategories } from '../../graphqlTypes'

const Item = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
  box-sizing: border-box;
  padding: 5px 0 5px 10px;
  text-align: left;
  &:last-child {
    border: 0;
  }
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    border: 0;
    margin: 8px 0 0;
    padding: 0;
    &:first-child {
      margin: 0;
    }
  }
`

const CategoryLink = styled(Link)`
  align-items: center;
  display: flex;
  text-decoration: none;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    text-decoration: underline;
  }
`

const CategoryIcon = styled.img`
  margin-right: 10px;
  width: 24px;
  height: 24px;
  object-fit: contain;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    width: 32px;
    height: 32px;
  }
`

const CategoryTitle = styled.span`
  color: ${({ theme }) => theme.palette.font.link};
  flex: 1;
  font-size: 12px;
  font-weight: normal;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    font-size: 13px;
    text-decoration: underline;
  }
`

const ItemAngle = styled(Angle)`
  width: 24px;
  height: 24px;
  margin-right: auto;
`

export default function MenuItem({ category }: { category: MysqlCategories }) {
  return (
    <Item>
      <CategoryLink to={category.fields!.pagePath!}>
        <LazyLoadComponent>
          <CategoryIcon
            alt={`${category.title}部門 受賞商品`}
            src={`${category.fields!.imageUrl}?auto=format&max-w=32&max-h=32`}
          />
        </LazyLoadComponent>
        <CategoryTitle>{category.title}</CategoryTitle>
        <ItemAngle color="gray" direction="right" />
      </CategoryLink>
    </Item>
  )
}
